import UpdateSalesInvoice from "../../../../components/@documents/sales_invoices/UpdateSalesInvoice";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function SalesInvoiceUpdatePage() {

    return (
        <UpdateSalesInvoice 
            routeType={routeTypes.admin}
        />
    )
}